import React from 'react';

type Props = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Modal de confirmation minimal (aucun composant équivalent n'existe dans mobile).
 */
const ConfirmModal = ({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel }: Props) => (
  <div className="confirm_modal">
    <div className="confirm_modal__content">
      <h2>{title || 'CONFIRM'}</h2>
      <p>{message}</p>
      <div className="confirm_modal__actions">
        <button className="confirm_modal__confirm" onClick={onConfirm}>
          {confirmLabel || 'CONFIRM'}
        </button>
        <button className="confirm_modal__cancel" onClick={onCancel}>
          {cancelLabel || 'CANCEL'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
